/*
    Update Preview Text allows corner radius, and color plates to
    put their value, which is their name, onto the label targeted with Target query.
    
    How to call.
    On the elements which have .value as their name.
    onclick="updatePreviewText(this, '{{ section.id }}-{{ block.id }} product-form__input_color_update')"

    Note:
    I'm imported updatePreviewText on the main-product.liquid page. And the function remains declaired for all pages underneith that
    So it's available in main-product.liquid and configuration-items.liquid.
    Importing them into both places will cause issues because of a function being declaired twice.

*/
function updatePreviewText(context, targetQuery){
    document.getElementById(targetQuery).innerText = ' ' + context.title;
}



